import { entityStore } from '~/utility/BinSentry-ui-utility';
import { html, LitEntity, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

const STATE = {
  UPLOADING_FILE: 'Uploading CSV File',
  PROCESSING_FILE: 'Processing CSV File',
};

class ImportCsvUpload extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.pollInterval = undefined;
  }

  static get properties() {
    return {
      state: { type: String, attribute: false },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity || !this.state) {
      return html``;
    }

    return html`
      <bn-loading><p>${this.state}...</p></bn-loading>
    `;
  }

  async uploadCsv(file) {
    try {
      this.dispatchEvent(new CustomEvent('upload-start'));
      this.state = STATE.UPLOADING_FILE;
      const fields = this.getActionFields(this.getCsvUploadAction);
      fields.set('fileName', file.name);
      const { entity } = await this.submitAction(this.getCsvUploadAction, fields);
      const uploadAction = entity.getActionByName('upload-csv');
      // upload to s3
      const fileField = uploadAction.getFieldByName('file');
      const arrayBuffer = await file.arrayBuffer();
      fileField.value = new Blob([arrayBuffer]);
      const { response } = await this.submitAction(uploadAction);
      const etag = response.headers.get('Etag');
      if (!etag) {
        this.state = undefined;
        this.dispatchEvent(new CustomEvent('upload-complete'));
        return;
      }
      this.etag = etag.replace(/"/g, '');
      this.state = STATE.PROCESSING_FILE;
      this._waitForFile();
    } catch (err) {
      this.state = undefined;
      this.dispatchEvent(new ErrorEvent('upload-error', { error: err.message }));
    }
  }

  disconnectedCallback() {
    clearInterval(this.pollInterval);
  }

  _waitForFile() {
    this.pollInterval = setInterval(this._checkFileIsProcessed.bind(this), 1000);
  }

  async _checkFileIsProcessed() {
    const { entity } = await entityStore.fetchWait(this.href);
    if (entity && this.etag === entity.properties.etag) {
      this.state = undefined;
      clearInterval(this.pollInterval);
      this.dispatchEvent(new CustomEvent('upload-complete'));
    }
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.getCsvUploadAction = this.entity.getActionByName('get-csv-upload');
  }
}

window.customElements.define('import-csv-upload', ImportCsvUpload);
